import React, { useState,useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import logo from '../assets/logo.png';
import './Login.css';
import { useLoading } from '../Utils/LoadingContext';
import LoginService from '../services/LoginService';
import {ValidateInput} from '../Utils/ValidateInput';
import showToast from "../Utils/ToastContainer";
import { isTokenValid } from '../Utils/authHelper';

const Login = () => {
  const navigate = useNavigate();
  const { setLoading } = useLoading();
  const [empCode, setEmpCode] = useState("");
  const [empPassword, setEmpPassword] = useState("");
  const [errors, setErrors] = useState({});

    const handleKeyDown = (e) => {
        if (e.key === "Enter") {
            handleSubmit(e);
        }
    };
    useEffect(() => {
      const token = localStorage.getItem("token");
      if (token && isTokenValid(token)) {
        navigate("/home");
      }
    }, []);
    
    const handleValidation = () => {
        const newErrors = {};
        const userCodeError = ValidateInput(empCode, "User Code");
        const passwordError = ValidateInput(empPassword, "Password");

        if (userCodeError) newErrors.empCode = userCodeError;
        if (passwordError) newErrors.empPassword = passwordError;

        setErrors(newErrors);

        return Object.keys(newErrors).length === 0;
    };
    
    
    const handleSubmit = async (e) => {
      e.preventDefault();
      if (!handleValidation()) return;
      setLoading(true);
      const loginRequest = { empCode, empPassword };
      const result = await LoginService.login(loginRequest);
  
      setLoading(false);
  debugger
      if (result.statusCode == "200") {
          localStorage.setItem("username", result.result.employeeName);
          localStorage.setItem("token", result.result.token);
          localStorage.setItem("departmentName", result.result.departmentName);
          localStorage.setItem("compantName", result.result.company);
          navigate("/home");
      } else if (result.statusCode == "423") {
          setEmpPassword("");
          showToast(result.message || "Account temporarily locked. Please try again later.", 'error', { autoClose: 3000 });
      } else if (result.statusCode == "429") {
          setEmpPassword("");
          showToast("Too many requests. Please wait a moment and try again.", 'error', { autoClose: 3000 });
      } else if (result.statusCode == "401") {
          setEmpCode("");
          setEmpPassword("");
          showToast(result.message || "Invalid Credential.", 'error', { autoClose: 700 });
      } else {
          setEmpCode("");
          setEmpPassword("");
          showToast(result.message || "Something went wrong. Please try again.", 'error', { autoClose: 700 });
      }
  };

    const handleUserCodeChange = (e) => {
        setEmpCode(e.target.value);
        setErrors((prevErrors) => ({ ...prevErrors, empCode: "" }));
    };

    const handleUserPasswordChange = (e) => {
        setEmpPassword(e.target.value);
        setErrors((prevErrors) => ({ ...prevErrors, empPassword: "" }));
    };

  return (
    <div className="login-wrapper d-flex align-items-center justify-content-center">
      <div className="login-card shadow">
        <div className="text-center mb-4">
          <img src={logo} alt="Logo" className="login-logo" />
        </div>
        <h4 className="text-center mb-3"></h4>
        <form>
          <div className="form-group mb-3 position-relative">
            <i className="fas fa-user input-icon"></i>
            <input
              type="text"
              className= {`form-control custom-input ps-5 ${errors.empCode ? 'is-invalid' : ''}`}
              placeholder="Employee Code"
              value={empCode}
              onChange={handleUserCodeChange}
              onKeyDown={handleKeyDown}
            />
            {errors.empCode && <div className="invalid-feedback">{errors.empCode}</div>}
          </div>
          <div className="form-group mb-4 position-relative">
            <i className="fas fa-lock input-icon"></i>
            <input
              type="password"
              className={`form-control custom-input ps-5 ${errors.empPassword ? 'is-invalid' : ''}`}
              placeholder="Password"
              value={empPassword}
              onKeyDown={handleKeyDown}
              onChange={handleUserPasswordChange}
            />
            {errors.empPassword && <div className="invalid-feedback">{errors.empPassword}</div>}
          </div>
          <button className="btn custom-login-btn w-100" type="button"
          onClick={handleSubmit}>
            <i className="fas fa-sign-in-alt me-2"></i> Login
          </button>
        </form>
      </div>
    </div>
  );
};

export default Login;
